/**
 * Monster Cart — AJAX add to cart
 *
 * When the Monster cart app is active on the page, "Add to cart" clicks are
 * intercepted before the theme's own handler runs (which redirects to the
 * cart page because settings.cart_type is "page"). The item is added with
 * the same AJAX request the theme uses and the visitor stays on the current
 * page — Monster opens its drawer by watching cart requests. Without the
 * app the theme keeps its default redirect behavior.
 */
(function () {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    productForm: 'form[action*="/cart/add"]',
    errorsContainer: '[data-cart-errors-container]',
    outerSection: '[data-section-id]',
    quickAddHolder: '[data-quick-add-holder]',
    closeError: '[data-close-error]',
    cartOnPage: '[data-cart-page], cart-drawer',
  };

  var classes = {
    loading: 'is-loading',
    added: 'is-added',
    visible: 'is-visible',
  };

  var closeErrorIcon =
    '<svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  document.addEventListener('click', onAddToCartClick, true);
  document.addEventListener('click', onErrorCloseClick);

  function monsterActive() {
    return !!document.querySelector('script[src*="/cart_renderer"]');
  }

  function onAddToCartClick(event) {
    if (!monsterActive()) return;

    var button = event.target.closest(selectors.addToCart);
    if (!button) return;

    var form = button.closest(selectors.productForm);
    if (!form) return;

    // The theme submits forms with file inputs natively — keep that behavior
    if (form.querySelector('[type="file"]')) return;

    // Stop the theme's own click handler, which redirects after adding
    event.preventDefault();
    event.stopPropagation();

    if (button.hasAttribute('disabled') || button.classList.contains(classes.loading)) return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    addToCart(form, button);
  }

  function addToCart(form, button) {
    var routes = (window.theme && window.theme.routes) || {};

    button.classList.add(classes.loading);
    button.disabled = true;

    var quickAddHolder = button.closest(selectors.quickAddHolder);
    if (quickAddHolder) {
      quickAddHolder.classList.add(classes.visible);
    }

    fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: new FormData(form),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          onAddError(response, button);
          return;
        }
        onAddSuccess(response, button);
      })
      .catch(function (error) {
        onAddError({message: (error && error.message) || 'Error', description: ''}, button);
      });
  }

  function onAddSuccess(response, button) {
    button.classList.remove(classes.loading);
    button.classList.add(classes.added);

    // The theme's cart listener resets the button states after this,
    // including the sticky cart bar button and quick-add holders
    button.dispatchEvent(
      new CustomEvent('theme:product:add', {
        detail: {
          response: response,
          button: button,
        },
        bubbles: true,
      })
    );

    if (typeof window.monster_refresh === 'function') {
      window.monster_refresh();
    }

    refreshCartUI();
  }

  function refreshCartUI() {
    if (document.querySelector(selectors.cartOnPage)) {
      // Cart markup is rendered on this page — let the theme rebuild it
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
      return;
    }

    var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
    fetch(root + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: {
              cartCount: cart.item_count,
            },
          })
        );
      })
      .catch(function () {});
  }

  function onAddError(data, button) {
    button.classList.remove(classes.loading);

    var outerContainer = button.closest(selectors.outerSection) || button.closest(selectors.quickAddHolder);
    var errorContainer = outerContainer && outerContainer.querySelector(selectors.errorsContainer);

    if (errorContainer) {
      var errorMessage = data.message;
      if (data.description && data.description !== data.message) {
        errorMessage = data.message + ': ' + data.description;
      }

      errorContainer.innerHTML =
        '<div class="errors">' + errorMessage + '<button type="button" class="errors__close" data-close-error>' + closeErrorIcon + '</button></div>';
      errorContainer.classList.add(classes.visible);
    }

    // The theme's cart listener resets the button states on this event
    button.dispatchEvent(
      new CustomEvent('theme:product:add-error', {
        detail: {
          response: data,
          button: button,
        },
        bubbles: true,
      })
    );
  }

  function onErrorCloseClick(event) {
    var closeButton = event.target.closest(selectors.closeError);
    if (!closeButton) return;

    var errorContainer = closeButton.closest(selectors.errorsContainer);
    if (errorContainer) {
      errorContainer.classList.remove(classes.visible);
    }
  }
})();
